// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-container {
    display: flex;
    justify-content: flex-start;
    max-width: 1200px;
    margin: auto;
    padding-top: 50px;
    height: 80vh;
  }
  
  .admin-sidebar {
    width: 200px;
    padding: 10px;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    border-radius: 8px;
  }

  .Admin-sidebar-item {
    padding: 10px;
    margin-bottom: 5px;
    cursor: pointer;
    text-align: center;
    font-weight: 600;
    border: 1px solid transparent;
    border-radius: 4px;
    width: 150px;
    max-width: 150px;
  }

.Admin-sidebar-item:hover,
.Admin-sidebar-item.active {
  background-color: #664B24;
  color: white;
}

.admin-content {
    flex-grow: 1;
    padding: 20px;
    margin-left: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .user-report {
    border: 2px solid #ddd;
    padding: 15px;
    margin: 20px 0;
    border-radius: 8px;
    background-color: #f9f9f9;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.admin-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/css/admin.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;EAClB;;AAEF;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,wCAAwC;EAC1C;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB","sourcesContent":[".admin-container {\n    display: flex;\n    justify-content: flex-start;\n    max-width: 1200px;\n    margin: auto;\n    padding-top: 50px;\n    height: 80vh;\n  }\n  \n  .admin-sidebar {\n    width: 200px;\n    padding: 10px;\n    height: 100%;\n    box-sizing: border-box;\n    overflow-y: auto;\n    border-radius: 8px;\n  }\n\n  .Admin-sidebar-item {\n    padding: 10px;\n    margin-bottom: 5px;\n    cursor: pointer;\n    text-align: center;\n    font-weight: 600;\n    border: 1px solid transparent;\n    border-radius: 4px;\n    width: 150px;\n    max-width: 150px;\n  }\n\n.Admin-sidebar-item:hover,\n.Admin-sidebar-item.active {\n  background-color: #664B24;\n  color: white;\n}\n\n.admin-content {\n    flex-grow: 1;\n    padding: 20px;\n    margin-left: 20px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background-color: white;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  .user-report {\n    border: 2px solid #ddd;\n    padding: 15px;\n    margin: 20px 0;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.admin-header{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
